import { Heading, OrderedList, ListItem } from '@dapperlabs/core-fe';
import React from 'react';

import { MomentsUsageCard } from '../Cards';
import { SectionProps } from '../models';
import SectionContainer from '../SectionContainer';

export const AboutMomentsUsage: React.FC<SectionProps> = ({
  sectionHeading,
  cards,
}) => {
  return (
    <SectionContainer>
      <>
        <Heading fontFamily='heading' textAlign='center'>
          {sectionHeading}
        </Heading>

        <OrderedList
          justifyContent={['center', 'center', 'space-between']}
          flexDirection={['column', 'column', 'row']}
          gap={['1rem', '1rem', '3rem']}
          display='flex'
          m={0}
          pt={['0.5rem', '3rem']}
          listStyleType='none'
        >
          {cards.map(({ fields }) => (
            <ListItem
              key={fields.cardHeading}
              flexBasis={['auto', 'auto', '23.5rem']}
              display='flex'
              mb={[8, 0]}
            >
              <MomentsUsageCard
                cardHeading={fields.cardHeading}
                cardImgSrc={fields.cardImage.fields.file.url}
                cardText={fields.cardText}
                tagLabel={fields.tagLabel}
              />
            </ListItem>
          ))}
        </OrderedList>
      </>
    </SectionContainer>
  );
};
